import Logo from "./Logo";
import Menu from "./Menu";
import Card from "./Card/Card";

const HiroMob = () => {
  return (
    <>
      
        <div className="wrapper-nav">
          <Logo />
          <Menu />
        </div>
        <Card />
      
    </>
  );
};

export default HiroMob;
